import { defineExtension } from "~/defineExtension/index.js";
import { zodSrcPath } from "~/defineExtension/zodTypes/zodSrcPath.js";
import { ApiBeforeWatch as ApiBeforeWatchAbstraction } from "~/abstractions/index.js";
import { z } from "zod";

export const ApiBeforeWatch = defineExtension({
    type: "Api/BeforeWatch",
    tags: { runtimeContext: "project", application: "api" },
    description: "Add custom logic to be executed before the API watch process.",
    multiple: true,
    paramsSchema: ({ project }) => {
        return z.object({
            src: zodSrcPath({ project, abstraction: ApiBeforeWatchAbstraction })
        });
    }
});
